import { render, staticRenderFns } from "./vrdetail.vue?vue&type=template&id=46be9cb1&"
import script from "./vrdetail.vue?vue&type=script&lang=js&"
export * from "./vrdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports